import StreamingError from './StreamingError';

export enum DoryServiceType {
  ALERT = 'alerts',
  MARKETDEPTH = 'marketdepth',
  NEWS = 'news',
  QUOTE = 'quotes',
  DEFAULT = 'streaming',

  MARKETDATA = 'fix-trades-ret',
  FIXTRADESRET = 'fix-trades-ret',

  BROKERAGE_TRADING = 'brokerage-trading',
}

export enum DoryMessageType {
  PING = 'ping',
  TOKENREFRESH = 'token-refresh',
  CANCEL = 'cancel',
  DSSTATUS = 'dsstatus',
  SNAPSHOT = 'snapshot',
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
  ADD = 'add',
  CHANGE = 'change',
  UPDATE = 'update',
  DELETE = 'delete',
  CONNECTIONS_EXCEEDED = 'connections-exceeded',

  // MarketData
  MARKETDATAREQUEST = 'marketdata-request',
  MARKETDATAREQUESTFAILED = 'request-failed',
  MARKETDATASNAPSHOT = 'marketdata-snapshot',
  MARKETDATAUPDATE = 'marketdata-update',
  FLOWTERMINATION = 'flow-termination',
  FLOWCANCELLATION = 'flow-cancellation',
  MARKETDATACANCELLATION = 'marketdata-cancellation',

  // QuoteTrading types
  QUOTEREQUEST = 'quote-request',
  QUOTEREQUESTMESSAGE = 'quote-message',
  QUOTEREQUESTREJECT = 'request-failed',
  QUOTEREQUESTFAILED = 'request-failed',

  QUOTEREQUESTFLOWTERMINATION = 'flow-termination',
  QUOTEREQUESTCANCELLATION = 'quote-cancellation',
  //
  QUOTEREJECT = 'quote-reject',
  QUOTEREJECTCONFIRMEND = 'flow-termination',

  QUOTEEXECUTION = 'trade-execution',
  QUOTEEXECUTIONREPORT = 'execution-report',

  // QuoteTrading Post Allocation types
  POSTTRADEALLOCATIONREQUEST = 'pta-request',
  POSTTRADEALLOCATIONRESPONSE = 'pta-acknowledgement',
  POSTTRADEALLOCATIONTERMINATION = 'flow-termination',

  // Brokerage trading
  BROKERAGE_UPDATE = 'execution-report-update',
}

export type DoryStreamingHeader = {
  service: DoryServiceType;
  messageType: DoryMessageType;
  version: string;
};
export type DoryStreamingMessage = {
  header: DoryStreamingHeader;
  payload?: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
};

export type StreamingEventHandler<T extends DoryStreamingMessage> = (
  msg: T,
  err: StreamingError
) => void;
